import React from 'react'
import { IconButton } from '@mui/material'
import { SettingsBackupRestoreRounded } from '@mui/icons-material'
import { COLOR } from '../../../utils/constants/color.constants'

const UIIconButtonRevert = ({ sx, ...props }) => {
  return (
    <IconButton
      sx={{
        borderRadius: '6px',
        '&:hover': {
          '& svg': {
            fill: COLOR.GREEN_SUCCESS,
          },
        },
        ...sx,
      }}
      {...props}
    >
      <SettingsBackupRestoreRounded sx={{ fill: COLOR.GRAY_MEDIUM }} />
    </IconButton>
  )
}

export default UIIconButtonRevert
